import { alphaSort } from 'vet-bones/utils';

const namespacesSort = alphaSort((item: [string, string]) => item[1]);

export const stringifySparqlNamespaces = (
  namespaces: Record<string, string>
): string =>
  Object.entries(namespaces)
    .sort(namespacesSort)
    .map(([prefix, iri]) => `prefix ${prefix}: <${iri}>`)
    .join('\n');

export const stringifyTurtleNamespaces = (
  namespaces: Record<string, string>
): string =>
  Object.entries(namespaces)
    .sort(namespacesSort)
    .map(([prefix, iri]) => `@prefix ${prefix}: <${iri}> .`)
    .join('\n');

export const stringifyNamespaceList = (
  namespaces: Record<string, string>
): string[] =>
  Object.entries(namespaces)
    .sort(namespacesSort)
    .map(([prefix, iri]) => `${prefix}=${iri}`);
